import { IFRAME, CONTENT } from '@/clients'
import { rmotrErrorHandler, shortenUUIDs } from '@/helpers'

/**
 * Get an IFrame
 * @param iframeId as UUID
 */
const fetchIFrameById = async iframeId => {
  const route = `iframes/${iframeId}`
  return CONTENT.get(route)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(rmotrErrorHandler(error)))
}

/**
 * Get an IFrame list
 * @param iframeIds as array
 */
const fetchIFrames = async iframeIds => {
  const route = `iframes?page_size=none&ids=${shortenUUIDs(iframeIds).join(
    ','
  )}`
  return CONTENT.get(route)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(rmotrErrorHandler(error)))
}

const fetchIFrameURL = async id => {
  const route = `/iframes/${id}/media`
  return IFRAME.get(route)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(rmotrErrorHandler(error)))
}

export { fetchIFrameById, fetchIFrames, fetchIFrameURL }
